module.exports = __webpack_public_path__ + "assets/901309ef4056c4e6e18a3977c3a0857d.png";